module.exports = __webpack_public_path__ + "img/Group-222.0cd5d2ed.svg";